export class LevelsConfig {
    public static levels = {
        '1': {
            array: [
                {
                    matrix: [
                        [1, 1, 1, 1, 1, 0, 0],
                        [1, 1, 1, 1, 1, 1, 0],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [0, 1, 1, 1, 1, 1, 1],
                        [0, 0, 1, 1, 1, 1, 1],
                    ],
                    pos: {
                        x: 0,
                        y: 0
                    }
                }
            ],
            type: 'fill_bar',
            drop_chance: {
                1: 20,
                2: 20,
                3: 20,
                4: 20,
                5: 20
            }
        },
        '2': {
            array: [
                {
                    matrix: [
                        [1, 0, 0, 1, 0, 0, 1],
                        [1, 0, 1, 1, 1, 0, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                    ],
                    pos: {
                        x: 0,
                        y: 0
                    }
                }
            ],
            type: 'drop_product',
            products: [
                {
                    i: 0,
                    j: 3,
                },
                {
                    i: 3,
                    j: 3,
                },
                {
                    i: 6,
                    j: 3,
                }
            ],
            drop_chance: {
                1: 25,
                2: 25,
                3: 25,
                4: 25,
                5: 25
            }
        },
        '3': {
            array: [
                {
                    matrix: [
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                    ],
                    pos: {
                        x: 0,
                        y: 0
                    }
                }
            ],
            type: 'background_release',
            drop_chance: {
                1: 20,
                2: 20,
                3: 20,
                4: 20,
                5: 20
            },
            image: 'shot_09',
        },
        '4': {
            array: [
                {
                    matrix: [
                        [1, 1, 1, 0, 1, 1, 1],
                        [1, 1, 1, 0, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 0, 1, 1, 1],
                        [1, 1, 1, 0, 1, 1, 1],
                    ],
                    pos: {
                        x: 0,
                        y: 0
                    }
                }
            ],
            type: 'fill_bar',
            drop_chance: {
                1: 20,
                2: 20,
                3: 25,
                4: 25,
                5: 10
            }
        },
        '5': {
            array: [
                {
                    matrix: [
                        [0, 1, 0, 0, 0, 1, 0],
                        [1, 1, 1, 0, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                    ],
                    pos: {
                        x: 0,
                        y: 0
                    }
                }
            ],
            type: 'drop_product',
            products: [
                {
                    i: 1,
                    j: 3,
                },
                {
                    i: 3,
                    j: 5,
                },
                {
                    i: 5,
                    j: 3,
                }
            ],
            drop_chance: {
                1: 25,
                2: 25,
                3: 25,
                4: 25,
                5: 25
            }
        },
        '6': {
            array: [
                {
                    matrix: [
                        [0, 1, 1, 0, 1, 1, 0],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [0, 1, 1, 1, 1, 1, 0],
                        [0, 0, 1, 1, 1, 0, 0],
                        [0, 0, 0, 1, 0, 0, 0],
                    ],
                    pos: {
                        x: 0,
                        y: 0
                    }
                }
            ],
            type: 'background_release',
            drop_chance: {
                1: 20,
                2: 20,
                3: 25,
                4: 25,
                5: 10
            },
            image: 'shot_14',
        },
        '7': {
            array: [
                {
                    matrix: [
                        [0, 1, 1, 0, 1, 1, 0],
                        [0, 1, 1, 1, 1, 1, 0],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 0, 1, 1, 1],
                        [1, 1, 1, 0, 1, 1, 1],
                        [1, 1, 1, 0, 1, 1, 1],
                    ],
                    pos: {
                        x: 0,
                        y: 0
                    }
                }
            ],
            type: 'fill_bar',
            drop_chance: {
                1: 20,
                2: 20,
                3: 20,
                4: 25,
                5: 15
            }
        },
        '8': {
            array: [
                {
                    matrix: [
                        [0, 1, 1, 0, 1, 1, 0],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [0, 1, 1, 1, 1, 1, 0],
                        [0, 1, 1, 1, 1, 1, 0],
                        [0, 1, 1, 1, 1, 1, 0],
                    ],
                    pos: {
                        x: 0,
                        y: 0
                    }
                },
                {
                    matrix: [
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [1, 0, 0, 0, 0, 0, 0],
                        [1, 0, 0, 0, 0, 0, 0],
                    ],
                    pos: {
                        x: 0,
                        y: 5
                    }
                },
                {
                    matrix: [
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 1],
                        [0, 0, 0, 0, 0, 0, 1],
                    ],
                    pos: {
                        x: 6,
                        y: 5
                    }
                }
            ],
            type: 'drop_product',
            products: [
                {
                    i: 1,
                    j: 3,
                },
                {
                    i: 3,
                    j: 4,
                },
                {
                    i: 5,
                    j: 3,
                }
            ],
            drop_chance: {
                1: 25,
                2: 25,
                3: 25,
                4: 25,
            }
        },
        '9': {
            array: [
                {
                    matrix: [
                        [1, 1, 1, 0, 1, 1, 1],
                        [1, 1, 1, 0, 1, 1, 1],
                        [1, 1, 1, 0, 1, 1, 1],
                        [1, 1, 1, 0, 1, 1, 1],
                        [1, 1, 1, 0, 1, 1, 1],
                        [1, 1, 1, 0, 1, 1, 1],
                        [1, 1, 1, 0, 1, 1, 1],
                    ],
                    pos: {
                        x: 0,
                        y: 0
                    }
                }
            ],
            type: 'background_release',
            drop_chance: {
                1: 20,
                2: 20,
                3: 20,
                4: 25,
                5: 15
            },
            image: 'shot_09',
        },
        '10': {
            array: [
                {
                    matrix: [
                        [0, 0, 1, 1, 1, 0, 0],
                        [0, 0, 1, 1, 1, 0, 0],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [0, 0, 1, 1, 1, 0, 0],
                        [0, 0, 1, 1, 1, 0, 0],
                    ],
                    pos: {
                        x: 0,
                        y: 0
                    }
                }
            ],
            type: 'fill_bar',
            drop_chance: {
                1: 15,
                2: 25,
                3: 20,
                4: 25,
                5: 15
            }
        },
        '11': {
            array: [
                {
                    matrix: [
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [0, 1, 1, 1, 1, 1, 0],
                        [0, 1, 1, 1, 1, 1, 0],
                        [0, 1, 1, 0, 1, 1, 0],
                    ],
                    pos: {
                        x: 0,
                        y: 0
                    }
                },
                {
                    matrix: [
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [1, 0, 0, 0, 0, 0, 1],
                        [1, 0, 0, 0, 0, 0, 1],
                    ],
                    pos: {
                        x: 0,
                        y: 5
                    }
                }
            ],
            type: 'drop_product',
            products: [
                {
                    i: 1,
                    j: 3,
                },
                {
                    i: 5,
                    j: 3,
                },
            ],
            drop_chance: {
                1: 25,
                2: 25,
                3: 25,
                4: 25,
            }
        },
        '12': {
            array: [
                {
                    matrix: [
                        [0, 0, 0, 1, 0, 0, 0],
                        [0, 0, 1, 1, 1, 0, 0],
                        [0, 1, 1, 1, 1, 1, 0],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                    ],
                    pos: {
                        x: 0,
                        y: 0
                    }
                }
            ],
            type: 'background_release',
            drop_chance: {
                1: 15,
                2: 25,
                3: 20,
                4: 25,
                5: 15
            },
            image: 'shot_14',
        },
        '13': {
            array: [
                {
                    matrix: [
                        [1, 1, 0, 0, 0, 1, 1],
                        [1, 1, 1, 0, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 0, 1, 1, 1],
                        [1, 1, 0, 0, 0, 1, 1],
                    ],
                    pos: {
                        x: 0,
                        y: 0
                    }
                }
            ],
            type: 'fill_bar',
            drop_chance: {
                1: 20,
                2: 20,
                3: 20,
                4: 20,
                5: 20
            }
        },
        '14': {
            array: [
                {
                    matrix: [
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [0, 1, 1, 1, 1, 1, 0],
                        [0, 1, 1, 1, 1, 1, 0],
                        [0, 0, 1, 1, 1, 0, 0],
                    ],
                    pos: {
                        x: 0,
                        y: 0
                    }
                }
            ],
            type: 'drop_product',
            products: [
                {
                    i: 3,
                    j: 3,
                },
            ],
            drop_chance: {
                1: 25,
                2: 25,
                3: 25,
                4: 25,
            }
        },
        '15': {
            array: [
                {
                    matrix: [
                        [1, 1, 1, 0, 1, 1, 1],
                        [1, 1, 1, 0, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [0, 0, 1, 1, 1, 0, 0],
                        [0, 0, 1, 1, 1, 0, 0],
                        [0, 0, 1, 0, 1, 0, 0],
                        [0, 0, 1, 0, 1, 0, 0],
                    ],
                    pos: {
                        x: 0,
                        y: 0
                    }
                },
                {
                    matrix: [
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [1, 1, 0, 0, 0, 1, 1],
                        [1, 1, 0, 0, 0, 1, 1],
                        [1, 1, 0, 0, 0, 1, 1],
                    ],
                    pos: {
                        x: 0,
                        y: 4
                    }
                },
            ],
            type: 'background_release',
            drop_chance: {
                1: 15,
                2: 25,
                3: 25,
                4: 25,
                5: 10
            },
            image: 'shot_09',
        },
        '16': {
            array: [
                {
                    matrix: [
                        [1, 1, 1, 0, 1, 1, 1],
                        [1, 1, 1, 0, 1, 1, 1],
                        [1, 1, 1, 0, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [0, 1, 1, 1, 1, 1, 0],
                        [0, 0, 1, 1, 1, 0, 0],
                    ],
                    pos: {
                        x: 0,
                        y: 0
                    }
                }
            ],
            type: 'fill_bar',
            drop_chance: {
                1: 20,
                2: 20,
                3: 20,
                4: 20,
                5: 20
            }
        },
        '17': {
            array: [
                {
                    matrix: [
                        [0, 0, 1, 1, 1, 0, 0],
                        [0, 1, 1, 1, 1, 1, 0],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [0, 1, 1, 1, 1, 1, 0],
                        [0, 0, 1, 1, 1, 0, 0],
                    ],
                    pos: {
                        x: 0,
                        y: 0
                    }
                }
            ],
            type: 'drop_product',
            products: [
                {
                    i: 3,
                    j: 3,
                }
            ],
            drop_chance: {
                1: 25,
                2: 25,
                3: 25,
                4: 25,
            }
        },
        '18': {
            array: [
                {
                    matrix: [
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 0, 1, 1, 1],
                        [1, 1, 0, 0, 0, 1, 1],
                        [1, 1, 0, 0, 0, 1, 1],
                        [1, 1, 0, 0, 0, 1, 1],
                        [1, 1, 0, 0, 0, 1, 1],
                    ],
                    pos: {
                        x: 0,
                        y: 0
                    }
                },
                {
                    matrix: [
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 1, 0, 1, 0, 0],
                        [0, 0, 1, 1, 1, 0, 0],
                        [0, 0, 1, 1, 1, 0, 0],
                    ],
                    pos: {
                        x: 2,
                        y: 4
                    }
                },
            ],
            type: 'background_release',
            drop_chance: {
                1: 20,
                2: 20,
                3: 20,
                4: 20,
                5: 20
            },
            image: 'shot_14',
        },
        '19': {
            array: [
                {
                    matrix: [
                        [1, 1, 0, 0, 1, 1, 1],
                        [1, 1, 1, 0, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 0, 1, 1, 1],
                        [1, 1, 1, 0, 0, 1, 1],
                    ],
                    pos: {
                        x: 0,
                        y: 0
                    }
                }
            ],
            type: 'fill_bar',
            drop_chance: {
                1: 20,
                2: 30,
                3: 30,
                4: 10,
                5: 10
            }
        },
        '20': {
            array: [
                {
                    matrix: [
                        [0, 1, 0, 1, 0, 1, 0],
                        [1, 1, 1, 1, 1, 1, 1],
                        [0, 1, 1, 1, 1, 1, 0],
                        [0, 1, 1, 1, 1, 1, 0],
                        [0, 1, 1, 1, 1, 1, 0],
                        [0, 1, 1, 1, 1, 1, 0],
                        [0, 1, 0, 1, 0, 1, 0],
                    ],
                    pos: {
                        x: 0,
                        y: 0
                    }
                },
                {
                    matrix: [
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [1, 0, 0, 0, 0, 0, 1],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                    ],
                    pos: {
                        x: 0,
                        y: 3
                    }
                },
                {
                    matrix: [
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [1, 0, 0, 0, 0, 0, 1],
                        [0, 0, 0, 0, 0, 0, 0],
                    ],
                    pos: {
                        x: 0,
                        y: 5
                    }
                },
            ],
            type: 'drop_product',
            products: [
                {
                    i: 2,
                    j: 4,
                },
                {
                    i: 4,
                    j: 4,
                },
            ],
            drop_chance: {
                1: 25,
                2: 25,
                3: 25,
                4: 25,
            }
        },
        '21': {
            array: [
                {
                    matrix: [
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 0, 0, 0, 0],
                        [1, 1, 1, 0, 0, 0, 0],
                        [1, 1, 1, 0, 0, 0, 0],
                        [1, 1, 1, 0, 0, 0, 0],
                    ],
                    pos: {
                        x: 0,
                        y: 0
                    }
                },
                {
                    matrix: [
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 1, 1, 1, 1],
                        [0, 0, 0, 1, 1, 1, 1],
                        [0, 0, 0, 1, 1, 1, 1],
                    ],
                    pos: {
                        x: 0,
                        y: 0
                    }
                }
            ],
            type: 'background_release',
            drop_chance: {
                1: 20,
                2: 30,
                3: 30,
                4: 10,
                5: 10
            },
            image: 'shot_09',
        },
        '22': {
            array: [
                {
                    matrix: [
                        [1, 1, 1, 0, 0, 0, 0],
                        [1, 1, 1, 0, 0, 0, 0],
                        [1, 1, 1, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                    ],
                    pos: {
                        x: 0,
                        y: 0
                    }
                },
                {
                    matrix: [
                        [0, 0, 0, 0, 1, 1, 1],
                        [0, 0, 0, 0, 1, 1, 1],
                        [0, 0, 0, 0, 1, 1, 1],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                    ],
                    pos: {
                        x: 4,
                        y: 0
                    }
                },
                {
                    matrix: [
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [1, 1, 1, 0, 0, 0, 0],
                        [1, 1, 1, 0, 0, 0, 0],
                        [1, 1, 1, 0, 0, 0, 0],
                    ],
                    pos: {
                        x: 0,
                        y: 4
                    }
                },
                {
                    matrix: [
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 1, 1, 1],
                        [0, 0, 0, 0, 1, 1, 1],
                        [0, 0, 0, 0, 1, 1, 1],
                    ],
                    pos: {
                        x: 4,
                        y: 4
                    }
                }
            ],
            type: 'fill_bar',
            drop_chance: {
                1: 10,
                2: 30,
                3: 30,
                4: 15,
                5: 15
            }
        },
        '23': {
            array: [
                {
                    matrix: [
                        [0, 0, 1, 0, 0, 0, 1],
                        [0, 1, 1, 0, 0, 1, 1],
                        [1, 1, 1, 0, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                    ],
                    pos: {
                        x: 0,
                        y: 0
                    }
                }
            ],
            type: 'drop_product',
            products: [
                {
                    i: 2,
                    j: 3,
                },
                {
                    i: 3,
                    j: 6,
                },
                {
                    i: 6,
                    j: 3,
                }
            ],
            drop_chance: {
                1: 25,
                2: 25,
                3: 25,
                4: 25,
            }
        },
        '24': {
            array: [
                {
                    matrix: [
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 0, 0, 0, 1, 1],
                        [1, 1, 0, 0, 0, 1, 1],
                        [1, 1, 0, 0, 0, 1, 1],
                        [1, 1, 0, 0, 0, 1, 1],
                        [1, 1, 0, 0, 0, 1, 1],
                    ],
                    pos: {
                        x: 0,
                        y: 0
                    }
                },
                {
                    matrix: [
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 1, 1, 1, 0, 0],
                        [0, 0, 1, 1, 1, 0, 0],
                    ],
                    pos: {
                        x: 2,
                        y: 5
                    }
                },
            ],
            type: 'background_release',
            drop_chance: {
                1: 10,
                2: 30,
                3: 30,
                4: 15,
                5: 15
            },
            image: 'shot_14',
        },
        '25': {
            array: [
                {
                    matrix: [
                        [1, 1, 1, 1, 1, 1, 0],
                        [1, 1, 1, 1, 1, 0, 0],
                        [1, 1, 1, 1, 0, 0, 0],
                        [1, 1, 1, 0, 0, 0, 0],
                        [1, 1, 0, 0, 0, 0, 0],
                        [1, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                    ],
                    pos: {
                        x: 0,
                        y: 0
                    }
                },
                {
                    matrix: [
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 1],
                        [0, 0, 0, 0, 0, 1, 1],
                        [0, 0, 0, 0, 1, 1, 1],
                        [0, 0, 0, 1, 1, 1, 1],
                        [0, 0, 1, 1, 1, 1, 1],
                        [0, 1, 1, 1, 1, 1, 1],
                    ],
                    pos: {
                        x: 6,
                        y: 1
                    }
                }
            ],
            type: 'fill_bar',
            drop_chance: {
                1: 20,
                2: 20,
                3: 20,
                4: 20,
                5: 20
            }
        },
        '26': {
            array: [
                {
                    matrix: [
                        [0, 0, 1, 1, 1, 0, 0],
                        [0, 1, 1, 1, 1, 1, 0],
                        [0, 1, 1, 1, 1, 1, 0],
                        [0, 1, 1, 1, 1, 1, 0],
                        [0, 1, 1, 1, 1, 1, 0],
                        [0, 1, 1, 1, 1, 1, 0],
                        [0, 1, 1, 1, 1, 1, 0],
                    ],
                    pos: {
                        x: 0,
                        y: 0
                    }
                },
                {
                    matrix: [
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [1, 0, 0, 0, 0, 0, 1],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                    ],
                    pos: {
                        x: 0,
                        y: 2
                    }
                },
                {
                    matrix: [
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [1, 0, 0, 0, 0, 0, 1],
                        [1, 0, 0, 0, 0, 0, 1],
                        [1, 0, 0, 0, 0, 0, 1],
                    ],
                    pos: {
                        x: 0,
                        y: 4
                    }
                }
            ],
            type: 'drop_product',
            products: [
                {
                    i: 1,
                    j: 4,
                },
                {
                    i: 3,
                    j: 3,
                },
                {
                    i: 5,
                    j: 4,
                }
            ],
            drop_chance: {
                1: 25,
                2: 25,
                3: 25,
                4: 25,
            }
        },
        '27': {
            array: [
                {
                    matrix: [
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 0, 0, 0, 0, 0, 1],
                        [1, 0, 0, 0, 0, 0, 1],
                        [1, 0, 0, 0, 0, 0, 1],
                        [1, 0, 0, 0, 0, 0, 1],
                    ],
                    pos: {
                        x: 0,
                        y: 0
                    }
                },
                {
                    matrix: [
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 1, 1, 0, 1, 1, 0],
                        [0, 1, 1, 0, 1, 1, 0],
                        [0, 1, 1, 0, 1, 1, 0],
                    ],
                    pos: {
                        x: 1,
                        y: 4
                    }
                }
            ],
            type: 'background_release',
            drop_chance: {
                1: 20,
                2: 20,
                3: 20,
                4: 20,
                5: 20
            },
            image: 'shot_09',
        },
        '28': {
            array: [
                {
                    matrix: [
                        [0, 1, 1, 0, 1, 1, 0],
                        [0, 1, 1, 0, 1, 1, 0],
                        [0, 1, 1, 0, 1, 1, 0],
                        [0, 1, 1, 0, 1, 1, 0],
                        [0, 1, 1, 1, 1, 1, 0],
                        [0, 1, 1, 1, 1, 1, 0],
                        [0, 1, 1, 1, 1, 1, 0],
                    ],
                    pos: {
                        x: 1,
                        y: 0
                    }
                },
                {
                    matrix: [
                        [1, 0, 0, 0, 0, 0, 1],
                        [1, 0, 0, 0, 0, 0, 1],
                        [1, 0, 0, 0, 0, 0, 1],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                    ],
                    pos: {
                        x: 0,
                        y: 0
                    }
                },
                {
                    matrix: [
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [1, 0, 0, 0, 0, 0, 1],
                        [1, 0, 0, 0, 0, 0, 1],
                        [1, 0, 0, 0, 0, 0, 1],
                    ],
                    pos: {
                        x: 0,
                        y: 4
                    }
                }
            ],
            type: 'fill_bar',
            drop_chance: {
                1: 35,
                2: 35,
                3: 10,
                4: 10,
                5: 10
            }
        },
        '29': {
            array: [
                {
                    matrix: [
                        [0, 0, 1, 1, 1, 0, 0],
                        [0, 0, 1, 1, 1, 0, 0],
                        [0, 0, 1, 1, 1, 0, 0],
                        [0, 0, 1, 1, 1, 0, 0],
                        [0, 0, 1, 1, 1, 0, 0],
                        [0, 0, 1, 1, 1, 0, 0],
                        [0, 0, 1, 1, 1, 0, 0],
                    ],
                    pos: {
                        x: 2,
                        y: 0
                    }
                },
                {
                    matrix: [
                        [0, 1, 0, 0, 0, 1, 0],
                        [1, 1, 0, 0, 0, 1, 1],
                        [0, 1, 0, 0, 0, 1, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                    ],
                    pos: {
                        x: 1,
                        y: 0
                    }
                },
                {
                    matrix: [
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 1, 0, 0, 0, 1, 0],
                        [1, 1, 0, 0, 0, 1, 1],
                        [0, 1, 0, 0, 0, 1, 0],
                    ],
                    pos: {
                        x: 2,
                        y: 4
                    }
                },
            ],
            type: 'drop_product',
            products: [
                {
                    i: 2,
                    j: 3,
                },
                {
                    i: 4,
                    j: 3,
                },
            ],
            drop_chance: {
                1: 25,
                2: 25,
                3: 25,
                4: 25,
            }
        },
        '30': {
            array: [
                {
                    matrix: [
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [1, 1, 1, 1, 1, 1, 1],
                        [0, 0, 0, 0, 1, 1, 1],
                        [0, 0, 0, 0, 1, 1, 1],
                        [0, 0, 0, 0, 1, 1, 1],
                        [0, 0, 0, 0, 1, 1, 1],
                    ],
                    pos: {
                        x: 0,
                        y: 0
                    }
                },
                {
                    matrix: [
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [0, 0, 0, 0, 0, 0, 0],
                        [1, 1, 1, 1, 0, 0, 0],
                        [1, 1, 1, 1, 0, 0, 0],
                        [1, 1, 1, 1, 0, 0, 0],
                    ],
                    pos: {
                        x: 0,
                        y: 0
                    }
                }
            ],
            type: 'background_release',
            drop_chance: {
                1: 35,
                2: 35,
                3: 10,
                4: 10,
                5: 10
            },
            image: 'shot_14',
        }
    }
}